import storage from 'store'
import {
	login,
	getInfo,
	logout,
	codeLogin
} from '@/api/login'

import {
	changeAccount
} from '@/api/public.js';
import {
	ACCESS_TOKEN
} from '@/store/mutation-types'
import {
	setToken,
	removeToken
} from '@/utils/auth'
import {
	closeWebSocket,
	resetWebSocket
} from '@/utils/socket'
import notification from 'ant-design-vue/es/notification'
import * as logistics from '@/api/logistics'

const user = {
	state: {
		token: '',
		name: '',
		welcome: '',
		avatar: '',
		roles: [],
		info: {},
		cityList: [],
		cityTotalNum: 0,
		userId:'',
	},

	mutations: {
		SET_TOKEN: (state, token) => {
			state.token = token
		},
		SET_NAME: (state, name) => {
			state.name = name
		},
		SET_AVATAR: (state, avatar) => {
			state.avatar = avatar
		},
		SET_ROLES: (state, roles) => {
			state.roles = roles
		},
		SET_INFO: (state, info) => {
			state.info = info
		},
		SET_PERMISSIONS: (state, permissions) => {
			state.permissions = permissions
		},
		SET_CITYS: (state, info) => {
			state.cityList = info
		},
		SET_CITYSNUM: (state, info) => {
			state.cityTotalNum = info
		},
		SET_MOBILE: (state, info) => {
			state.mobile = info
		},
		SET_USER_ID: (state, id) => {
			state.userId = id;
		},
		SET_USER_DEPT:(state, id) => {
			state.deptId = id;
		}
	},

	actions: {
		// 登录
		Login({
			commit
		}, userInfo) {
			const accountNo = userInfo.accountNo.trim()
			const password = userInfo.password
			const userType = 'ADMIN'
			const loginType = 'PASSWORD'
			const device = 'PC'
			const validCode = userInfo.validCode
			const validCodeReqNo = userInfo.validCodeReqNo
			return new Promise((resolve, reject) => {
				login(accountNo, password, validCode, validCodeReqNo, userType, loginType, device).then(res => {
					window.console.log('登录成功', res)
					if (res.success) {
						setToken(res.data.token)
						commit('SET_TOKEN', res)
						storage.set(ACCESS_TOKEN, res.data.token, 7 * 24 * 60 * 60 * 1000)
						const userInfo = res.data.userInfo || {}
						const firstRole = (userInfo.roleList && userInfo.roleList[0]) || {}
						storage.set('ACCOUNT_LIST', [{
							name: userInfo.name,
							mobile: userInfo.account,
							id: firstRole.id,
							roleName: firstRole.roleName
						}], 7 * 24 * 60 * 60 * 1000)
						// commit('SET_TOKEN', res.token)
						resolve()
					} else {
						notification.error({
							message: res.message,
							duration: 5 * 1000
						})
						reject(res.message)
					}
				}).catch(error => {
					reject(error)
				})
			})
		},
		// 验证码登录
		loginCode({
			commit
		},data){
			return new Promise((resolve, reject) => {
				codeLogin(data).then(res => {
					window.console.log('登录成功', res)
					if (res.success) {
						setToken(res.data.token)
						commit('SET_TOKEN', res)
						storage.set(ACCESS_TOKEN, res.data.token, 7 * 24 * 60 * 60 * 1000)
						const userInfo = res.data.userInfo || {}
						const firstRole = (userInfo.roleList && userInfo.roleList[0]) || {}
						// 与密码登录保持一致，写入角色 id，供切换账号模块显示判断（roleType != 18）
						storage.set('ACCOUNT_LIST', [{
							name: userInfo.name,
							mobile: userInfo.account,
							id: firstRole.id,
							roleName: firstRole.roleName
						}], 7 * 24 * 60 * 60 * 1000)
						resolve()
					} else {
						notification.error({
							message: res.message,
							duration: 5 * 1000
						})
						reject(res.message)
					}
				}).catch(error => {
					reject(error)
				})
			})
		},
		// 切换账号
		SwitchAccount({
			commit
		}, accountNo) {
			const userType = 'ADMIN'
			const loginType = 'SWITCH_ACCOUNT' // 切换账号登录类型
			const device = 'PC'
			return new Promise((resolve, reject) => {
				// 直接调用登录接口，只传账号，其他都为空
				changeAccount({userName:accountNo}).then(res => {
					if (res.success) {
						closeWebSocket()
						// 直接设置新 token，不执行 logout
						setToken(res.data.token)
						commit('SET_TOKEN', res.data.token)
						storage.set(ACCESS_TOKEN, res.data.token, 7 * 24 * 60 * 60 * 1000)
						// let accountList = storage.get('ACCOUNT_LIST')
						// if(!accountList.some(item => item.mobile === res.data.userInfo.account)){
						// 	accountList.push({name:res.data.userInfo.name,mobile:res.data.userInfo.account})
						// }
						// storage.set('ACCOUNT_LIST', accountList, 7 * 24 * 60 * 60 * 1000)
						notification.success({
							message: '切换账号成功',
							duration: 3
						})
						resolve(res)
					} else {
						notification.error({
							message: res.message || '切换失败',
							duration: 5
						})
						reject(res.message)
					}
				}).catch(error => {
					reject(error)
				})
			})
		},

		// 获取用户信息
		GetInfo({
			commit,
			state
		}) {
			return new Promise((resolve, reject) => {
				getInfo(state.token).then(res => {
					const user = res.data
					const avatar = user.avatar === '' ? require('@/assets/images/profile.jpg') : user.avatar
					if (user.roleCodes && user.roleCodes.length > 0) { // 验证返回的roles是否是一个非空数组
						commit('SET_ROLES', user.roleCodes)
						commit('SET_PERMISSIONS', user.permissions)
					} else {
						commit('SET_ROLES', ['ROLE_DEFAULT'])
					}
					commit('SET_INFO', user || {})
					commit('SET_NAME', user.nickName)
					commit('SET_AVATAR', avatar)
					commit('SET_MOBILE', user.mobile)
					commit('SET_USER_DEPT', user.deptId)
					closeWebSocket()
					commit('SET_USER_ID', user.userId)
					localStorage.setItem('userId', user.userId)
					resetWebSocket(user.userId)
					resolve(res)
				}).catch(error => {
					reject(error)
				})
			})
		},

		// 登出：先清本地并立即返回
		// remote=false：登录已过期（U0230 等）时不调 /logout，避免再次 U0230 拖慢跳转
		Logout({
			commit,
			state
		}, { remote = true } = {}) {
			return new Promise((resolve) => {
				const token = state.token
				closeWebSocket()
				commit('SET_TOKEN', '')
				commit('SET_ROLES', [])
				commit('SET_PERMISSIONS', [])
				commit('SET_USER_ID', '')
				commit('menu/SET_DEFAULT_ROUTE_PATH', '', { root: true })
				storage.remove(ACCESS_TOKEN)
				removeToken()
				localStorage.removeItem('userId')
				resolve()
				if (remote && token) {
					logout(token).catch(() => {})
				}
			})
		},
		// 获取运费模板 使用的省市区
		getCity({
			commit,
			state
		}) {
			return new Promise((resolve, reject) => {
				logistics.cityListTree().then((res) => {
					if (res.success) {
						/**为城市数组增加前端需要的isShow */
						let totalNum = 0
						if (res.data) {
							res.data.forEach((item, index) => {
								item.isShow = true;
								item.disabled = false
								item.cityNum = 0
								item.children.forEach((item1, index1) => {
									totalNum++
									item1.isShow = true;
									item1.disabled = false;
									item.cityNum += 1
								});
							});

							commit('SET_CITYS', res.data)
							commit('SET_CITYSNUM', totalNum)
						}
					}
				});
			})
		}
	}
}

export default user